import React, { Component } from 'react';
import { Table, Column, Cell } from 'components/Table';
import { Link } from 'react-router';
import Score from 'components/Score';
import LessonOverview from 'components/LessonOverview';

import { connect } from 'react-redux';
import { openModal } from 'actions/modal';
import { firebaseConnect, helpers } from 'react-redux-firebase';
import {CSVLink} from 'react-csv';

import './metrics.scss';
import '../../../sass/components/ui-list';

import { keyedObjToArr } from '../../util/index';
import StudentNotes from 'components/StudentNotes';
import {NameCell, CurrentLessonCell, OverallAverageCell, OverviewCell} from "./MetricsCells";
import {generateCSVPQ1} from "../../util/csv";



export class PQMetricsClassroom extends Component {

    constructor (props) {
        super(props);
    }

    overview(item){
        let lessonOverview = (<LessonOverview
            student={item}
            startIndex={1}
            endIndex={40}
        />);

        this.props.openModal(lessonOverview, {
            title : `${item.name} - Student Overview`,
            className: 'overview-modal pq1',
            onClose : (result) => { }
            }
        );
    }

    updateNotes(student, notes){
        const { firebase } = this.props;
        firebase.set(`/classrooms/${this.props.classroom.id}/students/${student.id}/notes`, notes);
    }

    notes(item){
        let notes = (<StudentNotes
            student={item}
            updateNotes={this.updateNotes.bind(this)}
        />);

        this.props.openModal(notes, {
                title : `Notes for ${item.name}`,
                className: 'notes-modal',
                onClose : (result) => {}
            }
        );

        this.props.openModal();
    }

	render () {
        let students = this.props.classroom.students ? keyedObjToArr(this.props.classroom.students) : [];
        let classroom = this.props.classroom;
        return (
            <div>
                <Table
                    data={students}
                    listClass="metrics-list"
                >
                    <Column
                        header="Name"
                        col="name"
                        tooltip={true}
                        cell={
                            <NameCell
                                student={students}
                                classroom={classroom}
                            />}
                    />
                    <Column
                        header="Current Lesson/Activity"
                        col="currentLessonActivity"
                        tooltip={true}
                        cell={<CurrentLessonCell
                            student={students}
                        />}
                    />
                    <Column
                        header="Overall Average"
                        col="overallAverage"
                        tooltip={true}
                        cell={<OverallAverageCell
                            student={students}
                        />}
                    />
                    <Column
                        header="Overview"
                        col="overview"
                        tooltip={true}
                        overview={this.overview.bind(this)}
                        notes={this.notes.bind(this)}
                        cell={<OverviewCell
                            student={students}
                        />}
                    />
                </Table>
                <div className='table-footer'>
                    <CSVLink
                        filename={`csv_${classroom.name}.csv`}
                        data={generateCSVPQ1(classroom, students)}
                        separator=','
                    >
                        Download student data as a CSV
                    </CSVLink>
                </div>
            </div>
        );
    }
}

export class PQ2MetricsClassroom extends Component {

    constructor (props) {
        super(props);
    }

    overview(item){
        let lessonOverview = (<LessonOverview student={item} />);

        this.props.openModal(lessonOverview, {
                title : `${item.name} - Student Overview`,
                className: 'overview-modal',
                onClose : (result) => { }
            }
        );
    }

    updateNotes(student, notes){
        const { firebase } = this.props;
        firebase.set(`/classrooms/${this.props.classroom.id}/students/${student.id}/notes`, notes);
    }

    notes(item){
        let notes = (<StudentNotes
            student={item}
            updateNotes={this.updateNotes.bind(this)}
        />);

        this.props.openModal(notes, {
                title : `Notes for ${item.name}`,
                className: 'notes-modal',
                onClose : (result) => {}
            }
        );

        this.props.openModal();
    }

    render () {
        let students = this.props.classroom.students ? keyedObjToArr(this.props.classroom.students) : [];
        let classroom = this.props.classroom;
        return (
            <div>
                <Table
                    data={students}
                    listClass="metrics-list"
                >
                    <Column
                        header="Name"
                        col="name"
                        tooltip={true}
                        cell={
                            <NameCell
                                student={students}
                                classroom={classroom}
                            />}
                    />
                    <Column
                        header="Current Lesson/Activity"
                        col="currentLessonActivity"
                        tooltip={true}
                        cell={<CurrentLessonCell
                            student={students}
                        />}
                    />
                    <Column
                        header="Overall Average"
                        col="overallAverage"
                        tooltip={true}
                        cell={<OverallAverageCell
                            student={students}
                        />}
                    />
                    <Column
                        header="Overview"
                        col="overview"
                        tooltip={true}
                        overview={this.overview.bind(this)}
                        notes={this.notes.bind(this)}
                        cell={<OverviewCell
                            student={students}
                        />}
                    />
                </Table>
            </div>
        );
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        openModal : (modal, props) => { dispatch(openModal(modal, props)); }
    };
};
const fbWrappedComponent = firebaseConnect([])(PQMetricsClassroom);

export default connect(
    ({ firebase }) => ({}),
    mapDispatchToProps
)(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/components/Metrics/PQMetricsClassroom.js